import { ElMessage } from "element-plus";
import { ElNotification } from "element-plus";
import { Notify } from "vant";
import { h } from "vue";
import chat from "./chatfunction";
import axios from "../util/axios";
import util from "../util/util";
import i18n from "../i18n/index";
import imageSending from "./ChatSend";
import historySending from "./ChatHistory";

function mergeMessages(...lists) {
  const messages = new Map();
  lists.forEach(list => (list || []).forEach(message => {
    const key = message.id == null ? JSON.stringify(message) : String(message.id);
    messages.set(key, { ...messages.get(key), ...message });
  }));
  return Array.from(messages.values()).sort((a, b) =>
    Number(a.create_time) - Number(b.create_time) || Number(a.id) - Number(b.id));
}

export default {
  state() {
    return {
      ...imageSending.state(),
      ...historySending.state(),
      chatList: [],
      curUser: {},
      count: 0,
      service: {},
      globalChatList: [],
      globalWindowCount: 2,
    };
  },
  getters: {
    chatMessages: state => uid => {
      const conversation = state.chatList.find(user => user.uid == uid) ||
        (state.service.uid == uid ? state.service : {});
      return (conversation.list || []).concat(state.pendingImages.filter(image => image.reciver_id == uid));
    },
  },
  mutations: {
    ...imageSending.mutations,
    ...historySending.mutations,
    clearChatList(state) {
      state.chatList = [];
    },
    rememberDesktopChatPosition(state, { address, view, position }) {
      [ ...state.chatList, state.service, ...state.globalChatList ]
        .filter(user => user.uid == address).forEach(user => {
          user.desktopScrollPositions = { ...user.desktopScrollPositions, [view]: position };
        });
    },
    rememberMobileChatPosition(state, { address, position }) {
      [...state.chatList, state.service].filter(user => user.uid == address)
        .forEach(user => { user.mobileScrollPosition = position; });
    },
    // 设置当前聊天用户id
    setCur(state, id) {
      let userindex = chat.checkHasUser.call(state, id);
      if (userindex != -1) {
        state.chatList[userindex].list = state.chatList[userindex].list || [];
        state.curUser = state.chatList[userindex];
      } else {
        state.curUser = {};
      }
    },

    clearcount(state, id) {
      let userindex = chat.checkHasUser.call(state, id);
      if (userindex != -1) {
        state.count = Math.max(0, state.count - state.chatList[userindex].count);
        state.chatList[userindex].count = 0;
      }
    },

    // 添加新用户到聊天列表
    addUserToChatList(state, user) {
      user.uid = user.id;
      let userindex = chat.checkHasUser.call(state, user.id);
      if (userindex == -1) {
        state.chatList.unshift({
          ...user,
          ...{
            content: "",
            type: "text",
            img: "",
            list: [],
            count: 0,
            create_time: Math.floor(new Date().getTime() / 1000),
            historyLoaded: false,
          },
        });
      }
    },

    // 向聊天列表插入消息
    // data: 聊天消息数据
    // index: 插入用户的索引值
    // history: 是否是历史消息
    addmsg(state, { data, index, history, globalindex }) {
      const conversation = state.chatList[index];
      if (!conversation) return;
      const latestId = Math.max(0, ...(conversation.list || []).map(item => Number(item.id) || 0));
      const duplicate = (conversation.list || []).some(item => item.id != null && item.id == data.id);
      conversation.list = mergeMessages(conversation.list, [data]);
      if (chat.checkId(data) == state.service.uid) {
        state.service.list = mergeMessages(state.service.list, [data]);
      }
      if (globalindex != -1 && state.globalChatList[globalindex]) {
        const window = state.globalChatList[globalindex];
        window.list = mergeMessages(window.list, [data]);
      }
      // 收到消息提示，如果全局列表存在则不提示
      if (!history && !duplicate && !chat.checkSenderIsSelf(data) && globalindex == -1) {
        if (!history) {
          chat.playAudioReceive();
          if (util.judgeTerminal()) {
            Notify({
              type: "success",
              message: (state.chatList[index].nickname || state.chatList[index].username) + ":" + data.content,
            });
          } else {
            ElNotification({
              title: state.chatList[index].nickname || state.chatList[index].username,
              message: h("i", { style: "color: teal" }, data.content),
            });
          }
        }
        // 如果不是当前聊天用户，未读消息+1
        if (
          state.chatList[index].uid != state.curUser.uid &&
          globalindex == -1
        ) {
          state.chatList[index].count++;
          state.count++;
        }
      }
      // 非历史消息，修改列表内容，推到顶部
      if (!history && !duplicate && Number(data.id) >= latestId) {
        let newObj = Object.assign(conversation, data);
        state.chatList.splice(index, 1);
        state.chatList.unshift(newObj);
        if (state.curUser.uid == newObj.uid) {
          state.curUser = state.chatList[0];
        }
      }
    },

    deleteUser(state, id) {
      let userindex = chat.checkHasUser.call(state, id);
      state.count -= state.chatList[userindex].count;
      state.chatList.splice(userindex, 1);
    },

    setService(state, data) {
      data.uid = data.id;
      state.service = {
        ...data,
        ...{
          content: "",
          type: "text",
          img: "",
          list: [],
          count: 0,
          create_time: Math.floor(new Date().getTime() / 1000),
          historyLoaded: false,
        },
      };
    },

    // 聊天窗口 - 添加用户
    addUserToGlobalChatListFromUser(state, user) {
      user.uid = user.id;
      let userindex = chat.checkGlobalChatListHasUser.call(state, user.id);
      if (userindex == -1) {
        if (state.globalChatList.length > state.globalWindowCount) {
          state.globalChatList.splice(state.globalWindowCount - 1, 0, {
            ...user,
            ...{
              show: true,
              content: "",
              type: "text",
              img: "",
              list: [],
              count: 0,
              create_time: Math.floor(new Date().getTime() / 1000),
            },
          });
        } else {
          state.globalChatList.push({
            ...user,
            ...{
              show: true,
              content: "",
              type: "text",
              img: "",
              list: [],
              count: 0,
              create_time: Math.floor(new Date().getTime() / 1000),
            },
          });
        }
      } else {
        let finalcount = state.globalWindowCount - 1;
        state.globalChatList[userindex].show = true;
        if (userindex > finalcount) {
          const user = state.globalChatList[userindex];
          state.globalChatList.splice(userindex, 1);
          state.globalChatList.splice(finalcount, 0, user);
          state.globalChatList[userindex];
        }
      }
    },
    addUserToGlobalChatListFromChatList(state, user) {
      let userindex = chat.checkGlobalChatListHasUser.call(state, user.uid);
      if (userindex == -1) {
        const newuser = Object.assign(
          {
            uid: user.uid,
            nickname: user.nickname,
            username: user.username,
            avatar: user.avatar,
            vip: user.vip,
            list: [...user.list],
          },
          {
            show: true,
            content: "",
            type: "text",
            img: "",
            count: 0,
            create_time: Math.floor(new Date().getTime() / 1000),
          }
        );
        if (state.globalChatList.length > state.globalWindowCount) {
          state.globalChatList.splice(state.globalWindowCount - 1, 0, newuser);
        } else {
          state.globalChatList.push(newuser);
        }
      } else {
        let finalcount = state.globalWindowCount - 1;
        state.globalChatList[userindex].show = true;
        if (userindex > finalcount) {
          const user = state.globalChatList[userindex];
          state.globalChatList.splice(userindex, 1);
          state.globalChatList.splice(finalcount, 0, user);
          state.globalChatList[userindex];
        }
      }
    },
    // 切换可视聊天窗口
    exchangePositionToEnabalVisible(state, id) {
      let userindex = chat.checkGlobalChatListHasUser.call(state, id);

      let finalcount = state.globalWindowCount - 1;
      state.globalChatList[userindex].show = true;
      if (userindex > finalcount) {
        const user = state.globalChatList[userindex];
        state.globalChatList.splice(userindex, 1);
        state.globalChatList.splice(finalcount, 0, user);
        state.globalChatList[userindex];
      }
    },
    // 显示/隐藏聊天窗口
    toogleUserFromChatWindowList(state, id) {
      let globalindex = chat.checkGlobalChatListHasUser.call(state, id);
      if (globalindex != -1) {
        state.globalChatList[globalindex].show = !state.globalChatList[
          globalindex
        ].show;
      }
    },

    // 聊天窗口 - 删除用户
    deleteUserFromChatWindowList(state, id) {
      let globalindex = chat.checkGlobalChatListHasUser.call(state, id);
      if (globalindex != -1) {
        state.globalChatList.splice(globalindex, 1);
      }
    },

    // 聊天窗口数量
    setGlobalWindowCount(state, count) {
      state.globalWindowCount = count;
    },
  },
  actions: {
    ...imageSending.actions,
    ...historySending.actions,
    // 收到消息
    chatEvent({ dispatch, commit, state }, data) {
      switch (data.opt) {
        // 初始化聊天列表
        case 0: {
          const currentId = state.curUser.uid;
          const previous = state.chatList;
          state.chatList = (data.contact || []).map(user => {
            const old = previous.find(item => item.uid == user.uid);
            const unread = (data.msg || []).filter(message => message.sender_id == user.uid);
            return { ...old, ...user,
              list: mergeMessages(old && old.list, user.list, unread),
              count: user.uid == currentId ? 0 : (user.unread_count == null ? unread.length : user.unread_count),
              historyLoaded: !!(old && old.historyLoaded), historyError: false,
            };
          });
          previous.forEach(user => {
            if (!state.chatList.some(item => item.uid == user.uid) &&
                (!(user.list || []).length || state.pendingImages.some(image => image.reciver_id == user.uid))) state.chatList.push(user);
          });
          state.curUser = state.chatList.find(user => user.uid == currentId) || {};
          const service = state.chatList.find(user => user.uid == state.service.uid);
          if (service) state.service = { ...state.service, ...service, id: state.service.uid };
          state.globalChatList.forEach(window => {
            const conversation = state.chatList.find(user => user.uid == window.uid);
            if (conversation) window.list = mergeMessages(window.list, conversation.list);
          });
          state.count = state.chatList.reduce((total, user) => total + Number(user.count || 0), 0);
          state.chatList.forEach(user => user.list.forEach(message => commit("settleChatImage", message)));
          state.chatList.forEach(user => {
            const old = previous.find(item => item.uid == user.uid);
            const afterId = old && (old.recoveryAfterId == null
              ? Math.max(0, ...(old.list || []).map(message => Number(message.id) || 0)) : Number(old.recoveryAfterId));
            const untilId = Math.max(Number(user.id) || 0, Number(old && old.recoveryUntilId) || 0);
            if (afterId && untilId > afterId) {
              dispatch("syncChatHistory", { address: user.uid, after_id: afterId, until_id: untilId });
            } else if (old && old.recoveryAfterId != null) {
              user.recoveryAfterId = null;
              user.recoveryUntilId = null;
            }
          });
          if (currentId) dispatch("wssend", { opt: 0, address: currentId, origin: true });
          break;
        }
        // 收到新消息
        case 1:
          commit("settleChatImage", data.msg);
          // 聊天列表是否拥有该用户
          let id = chat.checkId(data.msg);
          let userindex = chat.checkHasUser.call(state, id);
          let globalindex = chat.checkGlobalChatListHasUser.call(state, id);
          if (userindex != -1) {
            commit("addmsg", {
              data: data.msg,
              index: userindex,
              globalindex: globalindex,
            });
          } else {
            // 是陌生人的消息
            axios
              .post_form("/member/index/userdetail", {
                id: id,
              })
              .then((res) => {
                res = res.data;
                if (res.status == 200) {
                  let user = res.data;
                  userindex = chat.checkHasUser.call(state, id);
                  if (userindex != -1) {
                    commit("addmsg", {
                      data: data.msg,
                      index: userindex,
                      globalindex: globalindex,
                    });
                  } else {
                    commit("addUserToChatList", user);
                    commit("addmsg", {
                      data: data.msg,
                      index: 0,
                      globalindex: globalindex,
                    });
                  }
                }
              });
          }
          break;
        // 翻译
        case 2:
          break;
        // 历史消息
        case 3:
          if (data.request_id && !state.historyRequests.some(job => job.request_id === data.request_id)) break;
          data.data.forEach((item) => {
            let id = chat.checkId(item);
            let index = chat.checkHasUser.call(state, id);
            let globalindex = chat.checkGlobalChatListHasUser.call(state, id);
            if (index != -1) {
              commit("addmsg", {
                data: item,
                index: index,
                history: true,
                globalindex: globalindex,
              });
            }
          });
          if (data.request_id) commit("finishChatHistory", data);
          break;
        // 用户上线
        case 4:
          break;
        case 5:
          break;
        // 删除联系人结果
        case 6:
          commit("deleteUser", data.data);
          break;
        // 金币不足
        case 7:
          // ElMessage.error(i18n.global.t("tips.insufficientcredits"));
          ElMessage({
            iconClass: "iconfont icon-warning warningcolor",
            showClose: true,
            type: "error",
            message: h("p", null, [
              h("span", null, i18n.global.t("tips.nofreechat")),
              h(
                "a",
                {
                  style: "color: #f66; text-decoration: underline;",
                  href: util.judgeTerminal()
                    ? "/#/m/home/upgrade/index"
                    : "/#/w/home/upgrade",
                },
                i18n.global.t("tips.upmember")
              ),
              h("span", null, i18n.global.t("tips.continue")),
            ]),
          });
          break;
        // 需要升级
        case 8:
          ElMessage.error(i18n.global.t("tips.needupgrade"));
          break;
      }
    },
  },
};
